/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Address/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Address({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/Patient/Addresses/Address"
  
}) {
let editRelationAddressValueData = fromData.useDataFormat({ viewPath,
context: 'edit_relation_address',
format: fromFormat.format_address,
})
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<div
  data-testid="Address.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Address.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="edit_relation_address"
 format="/Data/format.js format_address"
 text={editRelationAddressValueData}
/>
</div>
</div>
{children}
</React.Fragment>)
}